import { FunctionComponent } from 'react';
import { FFFStorage } from '@fff-web/fff-utilities';
import { REACT_APP_MOBILE_BANNER_URL } from '../../../utils/dynamicLinks';
import type { OldMobileBannerProps } from './types';
import fffAppLogo from './fff-app-logo.png';
import * as styles from './OldMobileBanner.module.css';

const BANNER_SHOWN_KEY = 'old_mobile_banner_shown_on_session';

const OldMobileBanner: FunctionComponent<OldMobileBannerProps> = ({
  onBannerClose,
  onBannerClick,
  appMobileLink = '',
}) => {
  const hasBeenShown = FFFStorage.getFromStorage({ key: BANNER_SHOWN_KEY });
  const isUniversalLink = appMobileLink.includes(REACT_APP_MOBILE_BANNER_URL);
  const ButtonComponent = isUniversalLink ? 'a' : 'button';
  const buttonCustomProps = isUniversalLink ? { href: appMobileLink } : { type: 'button' as const };
  if (hasBeenShown) return null;
  return (
    <div className={styles.container} id="mobile-web-banner">
      <div className={styles.appContainer}>
        <button
          type="button"
          onClick={() => onBannerClose(true, BANNER_SHOWN_KEY)}
          className={styles.dbClose}
          data-testid="mobile-banner-close-button"
        >
          <p className={styles.dbCloseIcon}>
            <i className="far fa-times" />
          </p>
        </button>
        <img src={fffAppLogo} alt="app-logo" className={styles.logoImage} />
        <div className={styles.details}>
          <div className={styles.title}>FabFitFun</div>
          <div className={styles.description}>Open in the FabFitFun app</div>
        </div>
      </div>
      <ButtonComponent
        {...buttonCustomProps}
        onClick={onBannerClick}
        className={styles.openButton}
        data-testid="mobile-banner-open-button"
      >
        Open
      </ButtonComponent>
    </div>
  );
};

export default OldMobileBanner;
